"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorAttributes$ = exports.ValidationErrorAttributes$outboundSchema = exports.ValidationErrorAttributes$inboundSchema = void 0;
exports.validationErrorAttributesToJSON = validationErrorAttributesToJSON;
exports.validationErrorAttributesFromJSON = validationErrorAttributesFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.ValidationErrorAttributes$inboundSchema = z.object({
    input: z.any().optional(),
    loc: z.array(z.any()),
    msg: z.string(),
    type: z.string(),
});
/** @internal */
exports.ValidationErrorAttributes$outboundSchema = z.object({
    input: z.any().optional(),
    loc: z.array(z.any()),
    msg: z.string(),
    type: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ValidationErrorAttributes$;
(function (ValidationErrorAttributes$) {
    /** @deprecated use `ValidationErrorAttributes$inboundSchema` instead. */
    ValidationErrorAttributes$.inboundSchema = exports.ValidationErrorAttributes$inboundSchema;
    /** @deprecated use `ValidationErrorAttributes$outboundSchema` instead. */
    ValidationErrorAttributes$.outboundSchema = exports.ValidationErrorAttributes$outboundSchema;
})(ValidationErrorAttributes$ || (exports.ValidationErrorAttributes$ = ValidationErrorAttributes$ = {}));
function validationErrorAttributesToJSON(validationErrorAttributes) {
    return JSON.stringify(exports.ValidationErrorAttributes$outboundSchema.parse(validationErrorAttributes));
}
function validationErrorAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ValidationErrorAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ValidationErrorAttributes' from JSON`);
}
//# sourceMappingURL=validationerrorattributes.js.map